import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "user-page",
  "dark-class": "user-page-dark"
}
const _hoisted_2 = { class: "tool-bar-box" }
const _hoisted_3 = { class: "item-bar filter-box" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "item-bar mode-base" }
const _hoisted_8 = { class: "mode-box" }
const _hoisted_9 = { class: "item-bar operating-box" }
const _hoisted_10 = { class: "search-box" }
const _hoisted_11 = { class: "icon-base" }
const _hoisted_12 = {
  class: "user-box",
  "dark-class": "user-box-dark"
}
const _hoisted_13 = { class: "operating-btn" }
const _hoisted_14 = { class: "floor-box contact-box" }
const _hoisted_15 = { class: "item-box" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "手机号码", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 0,
  class: "item-box"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "住址", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  class: "floor-box event-box"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1)
const _hoisted_23 = { class: "event-item-box" }
const _hoisted_24 = { class: "item-box" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "加入日期", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "item-box" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "最后访问日期", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "floor-box data-box" }
const _hoisted_31 = { class: "item-box" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "可用积分", -1)
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "item-box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "访问次数", -1)
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "item-box" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "消费金额", -1)
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "floor-box info-box" }
const _hoisted_41 = { class: "avatar-box" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "basic-box" }
const _hoisted_44 = { class: "username-box" }
const _hoisted_45 = { class: "username" }
const _hoisted_46 = { class: "uid" }
const _hoisted_47 = { class: "status-box" }
const _hoisted_48 = {
  key: 0,
  class: "item-box"
}
const _hoisted_49 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_elem_options = _resolveComponent("elem-options")!
  const _component_comp_menu = _resolveComponent("comp-menu")!
  const _component_elem_prompt = _resolveComponent("elem-prompt")!
  const _component_comp_empty = _resolveComponent("comp-empty")!
  const _component_comp_model = _resolveComponent("comp-model")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-box",
            key: idx,
            id: 'filter_item_' + idx
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.filter_title["filter_item_" + idx] || "所有"), 1),
              _createVNode(_component_elem_icon, {
                class: "icon",
                name: "select"
              })
            ]),
            _createVNode(_component_elem_options, {
              el: '#filter_item_' + idx,
              data: item.data,
              onSelect: ($event: any) => (_ctx.onFilter(item.name, 'filter_item_' + idx, $event))
            }, null, 8, ["el", "data", "onSelect"])
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: _ctx.mode === 'basis' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeMode('basis')))
          }, "基础模式", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: _ctx.mode === 'concise' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeMode('concise')))
          }, "简洁模式", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_elem_icon, {
              class: "icon-box",
              name: "search"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "输入搜索内容",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitSearch && _ctx.onSubmitSearch(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item-box",
          key: idx
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_elem_icon, { name: "operating" }),
            _createVNode(_component_comp_menu, {
              absolute: true,
              position: "follow",
              maxWidth: "200px",
              value: _ctx.getMenu(item.status === 3),
              onSelect: ($event: any) => (_ctx.onSelectMenu(item, $event))
            }, null, 8, ["value", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("p", _hoisted_17, _toDisplayString(item.phone || "-"), 1)
            ]),
            (_ctx.mode === 'basis')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.getAddress(item)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.mode === 'basis')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", _hoisted_26, _toDisplayString(item.createdDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("p", _hoisted_29, _toDisplayString(item.lastAccess || item.createdDate), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("p", _hoisted_33, _toDisplayString(item.points || 0), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("p", _hoisted_36, _toDisplayString(item.accessFrequency || 0), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("p", _hoisted_39, "￥" + _toDisplayString(item.orderTotal || "0.00"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("img", {
                class: "img",
                src: item.avatar ? item.avatar.url : 'static/icon/user.svg'
              }, null, 8, _hoisted_42)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("p", _hoisted_45, _toDisplayString(item.username || "User"), 1),
                (item.gender != null && item.gender <= 1)
                  ? (_openBlock(), _createBlock(_component_elem_icon, {
                      key: 0,
                      class: "icon-box",
                      name: ['gender_male', 'gender_female'][item.gender]
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_46, _toDisplayString(item.uid || "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              (item.status === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createVNode(_component_elem_icon, {
                      class: "icon-box",
                      name: "disable"
                    }),
                    _createVNode(_component_elem_prompt, { title: "禁用状态" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128)),
      (_ctx.users && _ctx.users.length == 0)
        ? (_openBlock(), _createBlock(_component_comp_empty, {
            key: 0,
            botton: false,
            title: "用户列表为空",
            prompt: "注册的用户将在此显示"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_comp_model, {
      ref: "comp_model",
      title: _ctx.model_title,
      scroll: false
    }, {
      default: _withCtx(() => [
        (_ctx.model_url)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              ref: "iframe",
              src: _ctx.model_url,
              frameborder: "0",
              onLoad: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onLoadIframe && _ctx.onLoadIframe(...args))),
              width: "100%",
              height: "100%"
            }, null, 40, _hoisted_49))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}